export type RollVisibility = 'values' | 'hidden' | 'absent';

interface RollPrivacy {
    roll_private?: unknown;
    roll_by_encounter_creature_private?: unknown;
    roll_by_item_type?: unknown;
}

/** The page's viewer flag, never a permission stamped onto a shared roll row. */
export function rollViewerPermission(): number {
    const viewer = (window as unknown as { FateTide?: { user?: { isGM?: boolean } } }).FateTide?.user;
    return viewer?.isGM === true ? 1 : 0;
}

/** Shared by the full log, grouped history, dice and HUD projections. */
export function rollVisibility(roll: RollPrivacy, viewerPermission = rollViewerPermission()): RollVisibility {
    if (viewerPermission === 1) return 'values';
    const privacy = Number(roll.roll_private ?? 0);
    const hiddenCaster = Number(roll.roll_by_encounter_creature_private ?? 0) === 1;
    const lair = String(roll.roll_by_item_type ?? '').toLowerCase() === 'lair';
    if (privacy === 2 || (hiddenCaster && !lair)) return 'absent';
    return privacy > 0 ? 'hidden' : 'values';
}
